import PitchTemplateForm from './pitchTemplateForm.container';

export default PitchTemplateForm;
